export default __webpack_public_path__ + "static/media/0ac82ab88df8adeac5a68179be97a51f.png";